/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_EMPLOYEE_DROPDOWN,
  LOAD_EMPLOYEE_LEAVE_RECORD,
  LOAD_EMPLOYEE_LIST,
  LOAD_ATTENDANCE_VIEW,
  LOAD_PROJECT_LIST,
  LOAD_DOCUMENT
} from "./constants";

import {
  loadEmployeeLeaveRecord,
  loadEmployeeLeaveRecordSuccess,
  loadEmployeeLeaveRecordError,
  loadEmployeeList,
  loadEmployeeListSuccess,
  loadEmployeeListError,
  loadDocument,
  loadDocumentSuccess,
  loadDocumentError,
  loadEmployeeDropdownSuccess,
  loadEmployeeDropdownError,
  loadAttendanceViewSuccess,
  loadAttendanceViewError,
  loadProjectList,
  loadProjectListSuccess,
  loadAttendanceView,
  loadProjectListError,
} from "./actions";

import {
  loadEmployeeLeaveRecordAPI,
  loadEmployeeListAPI,
  loadEmployeeDropdownAPI,
  loadDocumentAPI,
  loadAttendanceViewAPI,
  loadProjectListAPI,
} from "./remotes";

function* loadEmployeeLeaveRecordSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE_LEAVE_RECORD),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadEmployeeLeaveRecord(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeLeaveRecordAPI, searchFilter);
        if (result) {
          yield put(loadEmployeeLeaveRecordSuccess(result));
        }
      } catch (error) {
        yield put(
          loadEmployeeLeaveRecordError(
            yield put(
              loadEmployeeLeaveRecordError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

function* loadEmployeeListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE_LIST),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadEmployeeList(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeListAPI, searchFilter);
        if (result) {
          yield put(loadEmployeeListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadEmployeeListError(
            yield put(
              loadEmployeeListError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

function* loadDocumentListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DOCUMENT),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadDocument(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadDocumentAPI, searchFilter);
        if (result) {
          yield put(loadDocumentSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDocumentError(
            yield put(
              loadDocumentError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

function* loadAttendanceViewSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ATTENDANCE_VIEW),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadAttendanceView(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadAttendanceViewAPI, searchFilter);
        console.log(result, "result")
        if (result) {
          yield put(loadAttendanceViewSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadAttendanceViewError(
            yield put(
              loadAttendanceViewError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}


function* loadProjectListSaga(){
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PROJECT_LIST),
    });

    const { explicitLoad } = load;
    const { projectarg } = explicitLoad || {};
    yield put(loadProjectList(projectarg));

    if (explicitLoad) {
      try {
        const result = yield call(loadProjectListAPI, projectarg);
        console.log(result, "result")
        if (result) {
          yield put(loadProjectListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadProjectListError(
            yield put(
              loadProjectListError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}


function* loadEmployeeDropdownSaga() {
  while (true) {
    yield race({
      metaData: take(LOAD_EMPLOYEE_DROPDOWN),
    });

    try {
      const department = yield call(loadEmployeeDropdownAPI, "dept", "post");
      const designation = yield call(loadEmployeeDropdownAPI, "allDesign", "post");
      const employee = yield call(loadEmployeeDropdownAPI, "allemployee", "post", "leave")
      const city = yield call(loadEmployeeDropdownAPI, "city", "post");
      let dropDownList = {
        departmentOptions:
          (department &&
            department.result &&
            department.result.length > 0 &&
            department.result
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.departmentName,
                    value: c._id,

                  }
                )
              )) ||
          [],
        designationOptions:
          (designation &&
            designation.result &&
            designation.result.length > 0 &&
            designation.result
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.designationName,
                    value: c._id,
                    departmentId: c.departmentId
                      ? c.departmentId._id
                      : null,
                  }
                )
              )) ||
          [],
        employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data
              .filter(f => f.status === 1)
              .map((data) =>
                Object.assign(
                  {},
                  {
                    label: `${data.employeeCode} - ${data.employeeName}`,
                    value: data.employeeCode,
                    _id: data._id,
                    departmentName: data.departmentId
                      ? data.departmentId.departmentName
                      : null, // Make sure it has a name
                    designationName: data.designationId
                      ? data.designationId.designationName
                      : null, // Get the designation name
                  }
                )
              )) ||
          [],
        cityOptions:
          (city &&
            city.result &&
            city.result.length > 0 &&
            city.result.filter(f => f.status === 1).map((c) =>
              Object.assign(
                {},
                {
                  label: c.cityName,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadEmployeeDropdownSuccess(dropDownList));
    } catch (error) {
      yield put(
        loadEmployeeDropdownError(
          (error && error.response && error.response.message) ||
          "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadEmployeeLeaveRecordSaga(),
    loadEmployeeListSaga(),
    loadEmployeeDropdownSaga(),
    loadDocumentListSaga(),
    loadAttendanceViewSaga(),
    loadProjectListSaga()
  ]);
}
